import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { Prompt } from 'react-router-dom';
import { Steps, Col, Row, Modal, Button } from 'antd';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { forEach } from 'lodash';
//Components
import BreadCrumb from '../../../../components/BreadCrumb';
import RunInstanceName from './runInstanceName';
import CustomerTypeMatchingConfig from './customerTypeMatchingConfig';
//fontawesome
import { faArrowLeft, faBan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//actions
import { getNSGlobalSettingsPageInfo } from '../../../../redux/actions/settings';
import {
  configRunInstance,
  getNSRIWatchListInitiate,
  getNSRIWhiteListInitiate,
  saveNSRunInstance,
  postRunRunInstance,
  getCustomerType
} from '../../../../redux/actions/ns/runInstance';

import style from './index.scss';
import SelectWatchList from './watchlist';
import SelectWhiteList from './whitelist';
import {
  saveNSMatchingConfigToStore,
  getNSMatchingConfigListData,
  getNSMatchingConfig
} from '../../../../redux/actions/ns/matchingConfig';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';
import { getModuleTypeByResourceCode } from '../../../../util/miscellaneousUtils';
import { convertDateInputToEpoch } from '../../../../util/timezone';
import { getSelectedResources } from '../../../../util/resourceManager';
const { nsResources } = getSelectedResources();

const { Step } = Steps;
const { confirm } = Modal;

const resourceCode = nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE;

export class RunInstanceCreateOrEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      isNextBtnDisable: true,
      isSaveBtnDisable: true,
      isRunBtnDisable: true,
      valuesChanged: false,
      configNameValues: {
        name: '',
        description: '',
        sourceId: ''
      },
      customerTypeMatchingConfig: {
        dateRange: [
          moment(new Date(), 'DD/MM/YYYY').subtract(30, 'days'),
          moment(new Date(), 'DD/MM/YYYY')
        ],
        matchingConfigs: null
      },
      watchListData: [],
      watchListChecked: false,
      whiteListData: [],
      key: 0,
      activeKey: '1',
      watchlistPageLoaded: false,
      whitelistPageLoaded: false
    };
  }

  handleWindowBeforeUnload = (e) => {
    const confirmationMessage = 'All updates to the parameters will be lost';
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  };

  observeElement = (elem) => {
    let resizeObserver = new ResizeObserver(() => {
      this.setState({ key: Math.random() });
    });

    resizeObserver.observe(elem);
  };

  componentDidMount() {
    const { createUpdateRunInstanceConfig, dispatch } = this.props;

    if (createUpdateRunInstanceConfig?.runInstanceConfig) {
      const data = createUpdateRunInstanceConfig?.runInstanceConfig;
      this.setState({
        configNameValues: {
          name: data ? data?.name : '',
          description: data ? data?.description : '',
          sourceId: data ? data?.sourceId : ''
        },
        customerTypeMatchingConfig: {
          dateRange:
            createUpdateRunInstanceConfig?.customerTypeMatchingConfig
              ?.dateRange || this.state.customerTypeMatchingConfig.dateRange,
          matchingConfigs: null
        },
        watchListData: {
          data: createUpdateRunInstanceConfig?.watchListData
        },
        whiteListData: {
          data: createUpdateRunInstanceConfig?.whiteListData
        }
      });
    }

    const element = document.getElementById('__create__runInstance__config__');
    element && this.observeElement(element);
    const { getNSGlobalSettingsPageInfo: getNSGlobalSettings } =
      this.props.apiActions;
    if (this.state.currentStep == '0')
      getNSGlobalSettings({ pageId: 'NS_IAD_WATCHLISTS' });
    this.saveRunInstanceConfigToStore(
      'customerTypeMatchingConfig',
      {
        dateRange: this.state.customerTypeMatchingConfig.dateRange,
        matchingConfigs: null
      },
      true
    );
    this.saveRunInstanceConfigToStore('watchListData', [], true);
    this.saveRunInstanceConfigToStore('whiteListData', [], true);
  }

  componentDidUpdate() {
    let beforeUnloadEventListener = false;
    const { getNSGlobalSettingsPageInfo: getNSGlobalSettings } =
      this.props.apiActions;
    if (this.state.valuesChanged && !beforeUnloadEventListener) {
      beforeUnloadEventListener = true;
      window.addEventListener('beforeunload', this.handleWindowBeforeUnload);
    }
    if (this.state.currentStep == '0' && this.state.watchlistPageLoaded) {
      this.setState({ watchlistPageLoaded: false });
    }
    if (this.state.currentStep == '1' && !this.state.watchlistPageLoaded) {
      getNSGlobalSettings({ pageId: 'NS_IAD_WATCHLISTS' });
      this.setState({ watchlistPageLoaded: true, whitelistPageLoaded: false });
    }
    if (this.state.currentStep == '2' && !this.state.whitelistPageLoaded) {
      getNSGlobalSettings({ pageId: 'NS_IAD_WHITELIST' });
      this.setState({ watchlistPageLoaded: false, whitelistPageLoaded: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
    this.resetState();
  }

  handleConfigNameChange = (name, value) => {
    this.setState({
      configNameValues: {
        ...this.state.configNameValues,
        [name]: value
      },
      valuesChanged: true
    });
  };

  resetState = () => {
    const s = {
      configNameValues: {
        name: '',
        description: '',
        sourceId: ''
      },
      customerTypeMatchingConfig: {
        dateRange: this.state.customerTypeMatchingConfig.dateRange
      },
      watchListData: [],
      whiteListData: [],
      currentStep: 0,
      isNextBtnDisable: true,
      valuesChanged: false
    };
    this.saveRunInstanceConfigToStore(
      'customerTypeMatchingConfig',
      {
        dateRange: this.state.customerTypeMatchingConfig.dateRange,
        matchingConfigs: null
      },
      true
    );
    this.saveRunInstanceConfigToStore('watchListData', [], true);
    this.saveRunInstanceConfigToStore('whiteListData', [], true);
    return s;
  };

  saveRunInstanceConfigToStore = (key, value, isValidationPassed) => {
    const { apiActions } = this.props;
    const { dispatch } = apiActions;

    if (
      (isValidationPassed && this.state.valuesChanged) ||
      (this.state.currentStep == 2 && !isValidationPassed)
    ) {
      if (dispatch) dispatch(configRunInstance({ [key]: value }));
      //enable disable next button
      this.setState({ isNextBtnDisable: false });
    } else if (this.state.currentStep == 1 && !isValidationPassed) {
      if (dispatch) dispatch(configRunInstance({ [key]: value }));
      this.setState({ isNextBtnDisable: true });
    } else {
      this.setState({ isNextBtnDisable: true });
    }
  };

  prev = () => {
    const { createUpdateRunInstanceConfig } = this.props;
    if (
      createUpdateRunInstanceConfig?.runInstanceConfig?.sourceId == '17' &&
      this.state.currentStep == 2
    ) {
      this.setState({
        currentStep: this.state.currentStep - 2,
        isNextBtnDisable: false
      });
    } else {
      this.setState({
        currentStep: this.state.currentStep - 1,
        isNextBtnDisable: false
      });
      if (this.state.currentStep === 1) {
        this.setState({ watchListChecked: true });
      }
    }
  };

  next = () => {
    const { createUpdateRunInstanceConfig } = this.props;
    if (
      createUpdateRunInstanceConfig?.runInstanceConfig?.sourceId == '17' &&
      this.state.currentStep == 0
    ) {
      this.setState({ currentStep: 1 });
    } else if (createUpdateRunInstanceConfig) {
      this.setState({ currentStep: this.state.currentStep + 1 });
    }
    if (
      createUpdateRunInstanceConfig?.runInstanceConfig?.sourceId != '17' &&
      !createUpdateRunInstanceConfig?.watchListData?.length
    ) {
      this.setState({ isNextBtnDisable: true });
    }

    if (
      this.state.currentStep === 0 &&
      createUpdateRunInstanceConfig?.runInstanceConfig?.sourceId != '17' &&
      this.state.watchListChecked === false
    ) {
      this.saveRunInstanceConfigToStore('watchListData', [], true);
      this.setState({ isNextBtnDisable: true });
    }
    if (this.state.currentStep === 2) {
      this.setState({ isNextBtnDisable: false });
    }
  };

  //handling back button
  routeHandler = (path) => {
    const { navigateTo } = this.props.apiActions;
    if (navigateTo) {
      navigateTo(path);
    }
  };

  handleReset = () => {
    const { currentStep } = this.state;
    switch (currentStep) {
      case 0:
        this.setState({
          configNameValues: {
            name: '',
            description: '',
            sourceId: ''
          },
          customerTypeMatchingConfig: {
            dateRange: '',
            matchingConfigs: null
          },
          valuesChanged: false
        });
        return;
      default:
        return;
    }
  };

  showResetConfirm = () => {
    confirm({
      title: 'Do you want to reset parameters?',
      icon: <ExclamationCircleOutlined />,
      content:
        'All parameters on this page will be reverted to their default values.',
      onOk: () => {
        this.handleReset();
      },
      onCancel: () => {
        console.log('Cancel');
      },
      okText: 'Reset'
    });
  };

  showCancelConfirm = () => {
    if (!this.state.valuesChanged) {
      this.routeHandler(`${ROUTE_AMLS_SMART_SCREENING}/runInstance`);
      return;
    }
    confirm({
      title: 'Do you want to cancel changes?',
      icon: <ExclamationCircleOutlined />,
      content: 'Changes made to the Run Instance Configuration will be lost.',
      onOk: () => {
        this.setState(
          {
            ...this.resetState()
          },
          () => this.routeHandler(`${ROUTE_AMLS_SMART_SCREENING}/runInstance`)
        );
      },
      onCancel: () => {
        console.log('Cancel');
      }
    });
  };

  convertMatchingMaptoArray = (matchingConfigsMap) => {
    let ar = [];
    forEach(matchingConfigsMap, function (value, key) {
      if (value !== null)
        ar.push({
          matchingConfigId: value.matchingConfigId,
          customerType: value.customerType,
          isDefault: value.isDefault
        });
    });
    return ar;
  };

  preparePayloadForSave = () => {
    const { watchListData, whiteListData, customerTypeMatchingConfig } =
      this.props.createUpdateRunInstanceConfig;

    let idValueArray = watchListData?.map(
      (item) => this.props.watchListData.data[item - 1].id
    );
    const whitelistIds = whiteListData?.map(
      (item) => this.props.whiteListData.data[item - 1].id
    );

    const startDate = customerTypeMatchingConfig?.dateRange[0];
    const endDate = customerTypeMatchingConfig?.dateRange[1];

    let startDate1 = new Date(startDate).setUTCHours(0, 0, 0, 0);
    let endDate1 = new Date(endDate).setUTCHours(0, 0, 0, 0);

    return {
      name: this.props.createUpdate.runInstanceConfig.name,
      description: this.props.createUpdate.runInstanceConfig.description,
      sourceId: this.props.createUpdate.runInstanceConfig.sourceId,
      watchlistIds: idValueArray,
      whitelistIds,
      startDate: convertDateInputToEpoch(new Date(startDate1), true),
      endDate: convertDateInputToEpoch(new Date(endDate1), true),
      matchingConfigs: this.convertMatchingMaptoArray(
        customerTypeMatchingConfig.matchingConfigs
      )
    };
  };

  handleSave = (type) => {
    confirm({
      title: `Do you want to save ${type === 'RUN' ? 'and run?' : '?'}`,
      icon: <ExclamationCircleOutlined />,
      content: `Your run instance configuration will be saved${
        type === 'RUN' ? ' and run.' : '.'
      }`,
      okText: type === 'RUN' ? 'Save & Run' : 'Save',
      onOk: () => {
        const { configNameValues } = this.state;
        const { dispatch } = this.props.apiActions;

        this.setState({ valuesChanged: false }, () => {
          let param = {
            ...configNameValues
          };
          this.props.apiActions.saveNSRunInstance({
            param: this.preparePayloadForSave(),
            type
          });
        });
      },
      onCancel: () => {
        console.log('Cancel');
      }
    });
  };

  handleOnBlur = () => {
    this.setState({ valuesChanged: true });
  };

  stepCompletion = (trigger) => {
    this.setState({ isSaveBtnDisable: trigger, isRunBtnDisable: trigger });
  };

  renderStepsButton = (steps) => {
    const { currentStep, isNextBtnDisable, isSaveBtnDisable, isRunBtnDisable } =
      this.state;
    const { createUpdateRunInstanceConfig } = this.props;

    return (
      <div className={style.stepsAction}>
        {currentStep > 0 && (
          <button
            id={'runInstanceConfig-backBtn'}
            className={style.btn}
            style={{ margin: '0 8px' }}
            onClick={this.prev}>
            Back
          </button>
        )}
        <button
          id={'runInstanceConfig-cancelBtn'}
          className={style.btn}
          style={{ margin: '0 8px' }}
          onClick={this.showCancelConfirm}>
          Cancel
        </button>
        {currentStep < steps.length - 1 && (
          <button
            id={'runInstanceConfig-nextBtn'}
            className={classnames(style.btn, style.btnPrimary)}
            style={{ margin: '0 8px' }}
            onClick={this.next}
            disabled={isNextBtnDisable}>
            Next
          </button>
        )}
        {currentStep === steps.length - 1 && (
          <Button
            id={'runInstanceConfig-runBtn'}
            style={{ margin: '0 8px' }}
            onClick={() => this.handleSave('RUN')}
            disabled={isRunBtnDisable}>
            Run
          </Button>
        )}
        {currentStep === steps.length - 1 && (
          <Button
            id={'runInstanceConfig-saveBtn'}
            type="primary"
            onClick={this.handleSave}
            style={{ margin: '0 8px' }}
            disabled={isSaveBtnDisable}
            loading={createUpdateRunInstanceConfig?.isLoading}>
            Save
          </Button>
        )}
      </div>
    );
  };

  riskScoringActiveHide = (obj, index) => {
    // return obj?.runInstanceConfig?.sourceId == '17' && index == 1;
    return false;
  };

  render() {
    const { currentStep, valuesChanged, configNameValues } = this.state;
    const { createUpdateRunInstanceConfig, settings, authentication } =
      this.props;
    let steps = [
      {
        title: 'Run Instance Name',
        content: (
          <RunInstanceName
            modulesList={getModuleTypeByResourceCode(
              authentication,
              resourceCode
            )}
            saveRunInstanceConfigToStore={this.saveRunInstanceConfigToStore}
            data={createUpdateRunInstanceConfig?.runInstanceConfig}
            handleSubmit={this.next}
            values={configNameValues}
            handleChange={this.handleConfigNameChange}
            handleOnBlur={this.handleOnBlur}
          />
        )
      },
      // {
      //   title: 'Select Watchlist',
      //   content: (
      //     <div>
      //       <SelectWatchList
      //         {...this.props}
      //         tableData={this.props?.watchListData}
      //         selectedRowKeysDataFromProps={
      //           createUpdateRunInstanceConfig?.watchListData
      //         }
      //         saveRunInstanceConfigToStore={this.saveRunInstanceConfigToStore}
      //       />
      //     </div>
      //   )
      // },
      // {
      //   title: 'Select Whitelist',
      //   content: (
      //     <SelectWhiteList
      //       {...this.props}
      //       tableData={this.props?.whiteListData}
      //       selectedRowKeysDataFromProps={
      //         createUpdateRunInstanceConfig?.whiteListData
      //       }
      //       saveRunInstanceConfigToStore={this.saveRunInstanceConfigToStore}
      //     />
      //   )
      // },
      {
        title: 'Customer Type & Matching Configurations',
        content: (
          <CustomerTypeMatchingConfig
            {...this.props}
            saveRunInstanceConfigToStore={this.saveRunInstanceConfigToStore}
            data={
              createUpdateRunInstanceConfig?.customerTypeMatchingConfig ||
              this.state.customerTypeMatchingConfig
            }
            handleSubmit={this.next}
            values={configNameValues}
            handleChange={this.handleConfigNameChange}
            getNSMatchingConfigListData={
              this.props.apiActions.getNSMatchingConfigListData
            }
            getNSMatchingConfig={this.props.apiActions.getNSMatchingConfig}
            individualMatchingConfigData={this.props.individualMatchingConfig}
            dataSource={this.props.matchingConfigListData}
            checkCompletion={this.stepCompletion}
            customerTypeList={this.props.customerTypeList}
            createUpdateRunInstanceConfig={createUpdateRunInstanceConfig}
          />
        )
      }
    ];

    //when user has added something than we'll show prompt **pending**
    return (
      <Row id="__create__runInstance__config__">
        <Prompt
          when={valuesChanged}
          message={(location) => {
            return location.pathname.startsWith('/login')
              ? true
              : `Changes you made may not be saved.`;
          }}
        />
        <Col span={24}>
          <div className={style.wrapper}>
            <div className={style.head}>
              <BreadCrumb
                crumbs={[
                  {
                    label: 'Run Instance',
                    linkTo: `${ROUTE_AMLS_SMART_SCREENING}/runInstance`
                  },
                  { label: 'Create Run Instance' }
                ]}
              />
              <div className={style.head_content} id="matchingConfig-head">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    onClick={() => {
                      if (currentStep === 0) {
                        this.saveRunInstanceConfigToStore(
                          'watchListData',
                          [],
                          true
                        );
                        this.saveRunInstanceConfigToStore(
                          'whiteListData',
                          [],
                          true
                        );
                        this.routeHandler(
                          `${ROUTE_AMLS_SMART_SCREENING}/runInstance`
                        );
                      } else {
                        this.prev();
                      }
                    }}
                    style={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faArrowLeft} color={'#000'} />
                  </div>
                  <h4>Create Run Instance</h4>
                </div>
              </div>
            </div>
            <div className={style.tabContent}>
              <React.Fragment>
                <Steps size="small" current={currentStep}>
                  {steps.map((item, index) => (
                    <Step
                      key={item?.title}
                      title={item?.title}
                      className={
                        this.riskScoringActiveHide(
                          createUpdateRunInstanceConfig,
                          index
                        )
                          ? style.stepTag
                          : ''
                      }
                      disabled={
                        this.riskScoringActiveHide(
                          createUpdateRunInstanceConfig,
                          index
                        )
                          ? true
                          : false
                      }
                      icon={
                        this.riskScoringActiveHide(
                          createUpdateRunInstanceConfig,
                          index
                        ) && (
                          <FontAwesomeIcon
                            icon={faBan}
                            style={
                              this.riskScoringActiveHide(
                                createUpdateRunInstanceConfig,
                                index
                              ) && {
                                ...{
                                  color: 'grey',
                                  height: '24px',
                                  width: '18px'
                                }
                              }
                            }
                          />
                        )
                      }
                    />
                  ))}
                </Steps>
                <div className={style.stepsContent}>
                  {steps[currentStep].content}
                </div>
                {this.renderStepsButton(steps)}
              </React.Fragment>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    authentication: state.authentication,
    createUpdateRunInstanceConfig: state.nsRunInstanceConfig.createUpdate,
    isLoading: state.app.isFetching,
    settings: state.settings,
    watchListData: state.nsRunInstanceConfig.watchList,
    whiteListData: state.nsRunInstanceConfig.whiteList,
    createUpdate: state.nsRunInstanceConfig.createUpdate,
    matchingConfigListData: state.nsMatchingConfig.matchingConfigList,
    individualMatchingConfig: state.nsMatchingConfig.matchingConfigById,
    runRunInstance: state.nsRunInstanceConfig.runRunInstance,
    customerTypeList: state.nsRunInstanceConfig.customerTypeList || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getNSGlobalSettingsPageInfo,
        getNSRIWatchListInitiate,
        getNSRIWhiteListInitiate,
        saveNSMatchingConfigToStore,
        getNSMatchingConfigListData,
        getNSMatchingConfig,
        saveNSRunInstance,
        postRunRunInstance,
        getCustomerType,
        dispatch
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RunInstanceCreateOrEdit);
